export default class DetalhesDoPedidoFluxoViewModel {
	constructor () {
		this.PedidoId = undefined;
		this.OrcamentoId = undefined;
		this.CodigoExternoPedido = undefined;
		this.CodigoExternoOrcamento = undefined;
		this.CodigoExternoCliente = undefined;
		this.NomeFantasia = undefined;
		this.RazaoSocial = undefined;
		this.NomeRepresentante = undefined;
		this.NomeProduto = undefined;
		this.CodigoProduto = undefined;
		this.NomeEmpresa = undefined;
		this.CnpjFormatado = undefined;
		this.TipoPedidoTexto = undefined;
		this.CurvaClienteTexto = undefined;
		this.Status = undefined;
		this.StatusPedidoParcela = undefined;
		this.TipoFluxoOrcamento = undefined;
		this.Cnpj = undefined;
		this.CnpjFormatado = undefined;
		this.ProgramacaoKanban = undefined;
		this.NumeroOrdemDeCompra = undefined;
	}
}